<template>
  <svg
    aria-hidden="true"
    tabindex="-1"
    role="presentation"
    class="icon icon-play"
    viewBox="0 0 32 32"
  >
    <path fill="#ffffff" d="M6.752,0.055l21.904,15.944L6.754,31.945" />
  </svg>
</template>
<script>
export default {};
</script>
